/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_DeactivateInputs */

const cs_action_deactivate = /** @type {(inputs: Action_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deaktivovat`)
};

const en_action_deactivate = /** @type {(inputs: Action_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate`)
};

/**
* | output |
* | --- |
* | "Deactivate" |
*
* @param {Action_DeactivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_deactivate = /** @type {((inputs?: Action_DeactivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_DeactivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_deactivate(inputs)
	return cs_action_deactivate(inputs)
});